import React from "react";
import CardPage from "../../layout/CardPage";
import { Listado } from "./Listado";

export const TodosServicios = () => {
  return (
    <CardPage titulo="Servicios">
      <Listado />
    </CardPage>
  );
};
